import * as RadixSwitch from '@radix-ui/react-switch';
import { cj, cm } from 'src/utils/classNames';

export interface Props extends Pick<
	RadixSwitch.SwitchProps,
	| 'asChild'
	| 'defaultChecked'
	| 'checked'
	| 'onCheckedChange'
	| 'disabled'
	| 'required'
	| 'name'
	| 'value'
	| 'className'
> {
	size: 'sm' | 'md';
	dataTestId?: string;
}

export default function Switch({
	size,
	checked,
	onCheckedChange,
	className,
	disabled,
	dataTestId,
	...rest
}: Props) {
	const rootSizeClassName = {
		sm: 'w-7 h-4',
		md: 'w-9 h-5',
	}[size];

	const thumbSizeClassName = {
		sm: 'size-3 data-[state=checked]:translate-x-3.5',
		md: 'size-4 data-[state=checked]:translate-x-4.5',
	}[size];

	return (
		<RadixSwitch.Root
			checked={checked}
			onCheckedChange={onCheckedChange}
			disabled={disabled}
			data-testid={dataTestId}
			className={cm(
				'relative rounded-xs transition-colors',
				rootSizeClassName,
				checked
					? 'bg-button-primary-bg hover:bg-button-primary-bg-hover'
					: 'bg-text-tertiary hover:bg-text-secondary',
				'data-disabled:bg-stroke-divider',
				className
			)}
			{...rest}
		>
			<RadixSwitch.Thumb
				className={cj(
					'block translate-x-0.5 rounded-xs bg-white transition-transform',
					'data-disabled:bg-text-disabled',
					thumbSizeClassName
				)}
			/>
		</RadixSwitch.Root>
	);
}
